<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cad</v-icon>{{$t('designfile.types')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <DesignFileTypeForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import DesignFileTypeForm from '../../components/designfiletype/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'DesignFileType';

const { mapFields } = createHelpers({
  getterType: 'designfiletype/getField',
  mutationType: 'designfiletype/updateField'
});

export default {
  name: 'DesignFileTypeCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    DesignFileTypeForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('designfiletype', ['create', 'reset'])
  }
};
</script>
